<template>
  <div>
    <b-container>
      <b-row>
        <b-col cols="4" class="text-left">
          <h5>{{ documentDetail.hospital_name }}</h5>
        </b-col>
        <b-col offset="2" cols="6" class="text-right">
          <b-row>
            <b-col>
              <label class="mt-1" for="invoice-date">วันที่ออกเอกสาร</label>
            </b-col>
            <b-col>
              <b-form-input
                id="invoice-date"
                class="header-input col-center"
                type="text"
                :value="documentDetail.created_at | filterDate"
                disabled
              />
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col>
              <label class="mt-1" for="invoice-id">เลขที่</label>
            </b-col>
            <b-col>
              <b-form-input
                id="invoice-id"
                class="header-input col-right"
                type="text"
                :value="documentDetail.in"
                disabled
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <payment-test-table-component :payment-list="paymentList" />
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col offset="1" cols="2">
          <label class="mt-1" for="payment-date">วันที่ชำระ</label>
        </b-col>
        <b-col cols="5">
          <div class="date-box">
            <div class="select-box">
              <div
                class="datepicker-trigger input-group "
                @mouseover="activeClosePaymentDate = true"
                @mouseleave="activeClosePaymentDate = false"
              >
                <input
                  id="payment-date"
                  class="form-control border-right-0 col-center"
                  type="text"
                  autocomplete="off"
                  placeholder="เลือกวันที่"
                  :value="formatDates(paymentDate)"
                />
                <div class="input-group-prepend bg-white">
                  <span
                    id="basic-addon1"
                    class="input-group-text border-left-0 rounded-right bg-white"
                  >
                    <fa-icon
                      v-show="activeClosePaymentDate"
                      :icon="['fas', 'times']"
                      class="icon"
                      @click="clearPaymentDate"
                    />
                  </span>
                </div>

                <AirbnbStyleDatepicker
                  :trigger-element-id="'payment-date'"
                  :mode="'single'"
                  :show-shortcuts-menu-trigger="false"
                  :fullscreen-mobile="true"
                  :date-one="paymentDate"
                  @date-one-selected="
                    (val) => {
                      $emit('update:paymentDate', val);
                    }
                  "
                />
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="3" class="text-right">
          <label class="mt-1" for="payment-methods">ช่องทางการชำระเงิน</label>
        </b-col>
        <b-col cols="6" class="text-left pr-0">
          <b-form-group class="mt-1">
            <b-form-radio-group
              :checked="paymentMethodsSelected"
              name="payment-methods"
              :options="paymentMethods"
              @change="
                (c) => {
                  $emit('update:paymentMethodsSelected', c);
                }
              "
            />
          </b-form-group>
        </b-col>
        <b-col cols="3" class="text-left pl-0">
          <b-form-input
            id="check-number"
            type="text"
            :value="checkNumber"
            :disabled="!isCheckMethod"
            @change="
              (c) => {
                $emit('update:checkNumber', c);
              }
            "
          />
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="3" class="text-right">
          <label class="mt-1" for="payment-date">สถานะชำระเงิน</label>
        </b-col>
        <b-col cols="9" class="text-left">
          <b-form-group>
            <b-form-radio-group
              v-model="paymentStatusSelected"
              name="payment-status"
              :options="paymentStatus"
              text-field="name"
              value-field="id"
              @change="
                (c) => {
                  $emit('update:paymentStatusSelected', c);
                }
              "
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import PaymentTestTableComponent from "../../components/Account/PaymentTestTableComponent";
import moment from "moment-timezone";
import format from "date-fns/format";
import { mapGetters } from "vuex";

export default {
  name: "PaymentModalComponent",
  components: {
    PaymentTestTableComponent,
  },
  props: {
    paymentList: {
      type: Array,
    },
    documentDetail: {
      // type: Object
    },
    payload: {
      type: Object,
    },
    paymentDate: {},
    paymentMethodsSelected: {},
    paymentStatusSelected: {},
    checkNumber: {},
    isCheckMethod: {},
  },
  mounted() {},
  computed: {
    ...mapGetters({
      paymentStatus: "Account/getPaymentStatuses",
    }),
  },
  data() {
    return {
      //   paymentDate: "",
      //   paymentMethodsSelected: "", // Must be an array reference!
      paymentMethods: [
        { text: "โอนเข้าบัญชี", value: "bank" },
        { text: "เงินสด", value: "cash" },
        { text: "ชำระเป็นเช็ค", value: "check" },
      ],
      // paymentStatus: [
      //   { text: "รอจ่าย", value: false },
      //   { text: "จ่ายแล้ว", value: true }
      // ],
      //   paymentStatusSelected: "",
      //   checkNumber: "",
      //   isCheckMethod: false,
      dateFormat: "D/MM/YYYY",
      activeClosePaymentDate: false,
    };
  },
  watch: {
    // paymentMethodsSelected(newVal, oldVal) {
    //   if (newVal === "check") {
    //     this.isCheckMethod = true;
    //   } else {
    //     this.isCheckMethod = false;
    //     this.checkNumber = "";
    //   }
    //   var payload = this.payload;
    //   payload.paymentMethod = newVal;
    //   this.$emit("update:payload", payload);
    // },
    // paymentDate(newVal, oldVal) {
    //   var payload = this.payload;
    //   payload.paymentDate = newVal;
    //   this.$emit("update:payload", payload);
    // },
    // paymentStatusSelected(newVal, oldVal) {
    //   var payload = this.payload;
    //   payload.paymentStatus = newVal;
    //   this.$emit("update:payload", payload);
    // },
    // checkNumber(newVal, oldVal) {
    //   var payload = this.payload;
    //   payload.checkNumber = newVal;
    //   this.$emit("update:payload", payload);
    // }
  },
  methods: {
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    clearPaymentDate() {
      //   this.paymentDate = "";
      this.$emit("update:paymentDate", "");
    },
  },
  filters: {
    filterDate(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
};
</script>

<style scoped>
.header-input {
  width: 10rem;
}
</style>

<style>
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #fb822b;
  background-color: #fb822b;
}
.custom-checkbox
  .custom-control-input:indeterminate
  ~ .custom-control-label::before {
  border-color: #fb822b;
  background-color: #fb822b;
}
</style>
